import { render, staticRenderFns } from "./under_collarbone.vue?vue&type=template&id=d114b1e2"
import script from "./under_collarbone.vue?vue&type=script&lang=js"
export * from "./under_collarbone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports